module.exports = __webpack_public_path__ + "img/pitchup-favicon.295c5d0.svg";